import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import { httpGetCountries } from '../http/experience-shell.http'

export const useGetCountries = (search?: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.EXPERIENCE_SHELL_COUNTRIES],
		queryFn: () =>
			httpGetCountries({
				params: { responseType: 'extended', name: search }
			})
	})
